import { render } from "./RegisteredCoOperativeOnboarding.vue?vue&type=template&id=ee3c090c&scoped=true&ts=true"
import script from "./RegisteredCoOperativeOnboarding.vue?vue&type=script&lang=ts"
export * from "./RegisteredCoOperativeOnboarding.vue?vue&type=script&lang=ts"

import "./RegisteredCoOperativeOnboarding.vue?vue&type=style&index=0&id=ee3c090c&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3c090c"]])

export default __exports__